import { Box, Container, Heading, Text, Button } from '@chakra-ui/react'
import React from 'react'
import ButtonTheme from './ButtonTheme'
import ContactFormButton from "./old-site/ContactForm2";

const Interested = ({propertyDetail}) => {
  return (
    <Box my={40} textAlign={"center"}>
        <Container maxW={{ lg: "60%", base: "90%" }}>
            <Heading mb={4} color={"DarkBlue"} fontSize={"5xl"}>Interested in leasing this property?</Heading>
            <Text mb={16} color={"black"}>Contact us today to inquire about available properties, and let’s find the perfect space for your practice.</Text>
          

        {/* {propertyDetail && propertyDetail.available && (  */}
           <ContactFormButton property={propertyDetail}>
              {({ showModal }) => (
                <Button
                  className="contactButton bk-button"
                  onClick={showModal}
                  fontWeight={"400"}
                  h={"48px"}
                  w={{ sm: "208px", base: "100%" }}
                  mt={"5 !important"}
                  borderRadius={"30px"}
                  bgColor={"white !important"}
                  textTransform={"math-auto"}
                  border={"1px solid"}
                  borderColor={"Teal !important"}
                  _hover={{
                    filter: "brightness(95%)",
                    transform: "translateY(-2px)",
                    boxShadow: "lg",
                  }}
                  color="black !important"
                  id="btn_interested_make_an_inquiry"
                >
                  Make an Inquiry
                </Button>
              )}
            </ContactFormButton>
            {/* )} */}



        </Container>
    </Box>
  )
}

export default Interested